import GradientBlock from "components/GradientBlock";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { createAPI } from "services/api/api";

const WithdrawalTest = () => {
  const api = createAPI();

  const { search } = useLocation();
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .post(`https://stage.twotwentyk.io/api/onramper/offramp${search}`)
      .catch((e) => {
        console.log("WithdrawalTest request error", e);
        setError(e.response.data.message);
      });
  }, []);

  return (
    <>
      <GradientBlock additionalClassName="gradient-block--purple">
        <h1 className="gradient-block__title">
          {!error ? (
            <span
              dangerouslySetInnerHTML={{
                __html:
                  "Your withdrawal is being processed. <br /> You may close this page.",
              }}
            />
          ) : (
            error
          )}
        </h1>
      </GradientBlock>
    </>
  );
};

export default WithdrawalTest;
